import React, { Component, useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import ReactGA from "react-ga";
import Site from "screen/sites/Site";
import SiteListing from "screen/sites/SiteListing";
import Battery from "screen/batteries/Battery";
import ServiceListing from "screen/ServiceRequest/ServiceListing";
import ServiceRequest from "screen/ServiceRequest/ServiceRequest";
import ViewService from "screen/ServiceRequest/ViewService";
import BattriesList from "screen/batteries/BattriesList";
import SignIn from "./components/authentication/Signin";
import ForgotPassword from "./components/authentication/ForgotPassword";
import ResetPassword from "./components/authentication/ResetPassword";
import Swapping from "./components/swappingStations/Swapping";
import SwappingStationEnergyComponent from "./components/swappingStations/SwappingStationEnergyComponents";
import Assets from "screen/assets/Asset";
import SwapingStation from "./components/swappingStations/SwappingStation";
import SwappingDetails from "./components/swappingStations/SwappingDetails";
import Analytics from "./components/sitecomponent/Analytics";
import SiteInformation from "./screen/sites/SiteInformation";
import AOS from "aos";
import LocalStorageService from "services/tokenlocalstorage.service";
import { isMobile } from "react-device-detect";
import "aos/dist/aos.css";
import "antd/dist/antd.css";
import "./App.css";
import "./fonts.css";
import "fonts/jioType/stylesheet.css";
import Dashboard from "screen/dashboard/Dashboard";
import { getRequest, postRequest } from "services/axiosBaseClient";
import decode from "jwt-decode";
import {
  role_admin,
  role_super_admin,
  role_operator,
} from "components/common/Constants";
import UserProfile from "screen/form/AdminUserProfile";
import Alerts from "screen/Alerts/Alerts";
import Tracking from "screen/tracking/Tracking";
import AppContext from "./components/ApplicationContext";
import Addpricing from "screen/Pricing/AddPricing";
import Pricing from "screen/Pricing/Pricing";
import FotaMain from "screen/FOTA/Fota";
import AddFirmware from "screen/FOTA/ViewFirmware";
import EditFirmware from "screen/FOTA/EditFirmware";
import ViewFirmwareSwapStation from "screen/FOTA/ViewSwapStationUpgrade";
import Invoice from "./components/InvoiceComponent";
import AddInvoice from "./components/AddInvoiceComponent";
import PriceInvoice from "./components/PriceInvoiceComponent";

import Addzone from "screen/form/Addzone";
import AddSwapStation from "screen/form/AddSwapStation";
import AddSite from "screen/form/AddSite";
import AddBattery from "screen/form/AddBattery";
import AddMakers from "screen/form/AddMakers";
import AddModel from "screen/form/AddModel";
import AddVehicle from "screen/form/AddVehicle";

import UserList from "screen/user/UserList";
import AddAdmin from "screen/form/AddAdmin";
import AddOperator from "screen/form/AddOperator";
import AddDriver from "screen/form/AddDriver";
import AddRole from "screen/form/AddRole";

import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";
// import report from "screen/Reports/reports";
// import Schedule from "./components/tripSchedule/Schedule.js";
import reports from "screen/Reports/reports"; //htmlToImage npm issue.
import Track from "screen/tracking/Track";
import Schedule from "./components/schedule/Schedule";
import AddSchedule from "./components/AddSchedule";
import FaqPage from "screen/FAQ/FAQpage";
import PrivacyPolicyPortal from "screen/PPandTC/PrivacyPolicyEP";
import PrivacyPolicyApp from "screen/PPandTC/PrivacyPolicyDA";
import TermsConditionsApp from "screen/PPandTC/TermsConditionsDA";
import TermsConditionsPortal from "screen/PPandTC/TermsConditionsEP";

async function fetchUser() {
  try {
    const user = await getRequest(
      "/customer-gateway/evses/detailed?evses={evseID}"
    );
    console.log(JSON.stringify(user));
  } catch (error) {
    //Log errors
  }
}
//fetch te use by calling the api

// fetchUser();
const checkAuth = () => {
  const token = LocalStorageService.getToken();
  const refreshToken = LocalStorageService.getLocalRefreshToken();
  if (!token || !refreshToken) {
    return false;
  }
  try {
    const { exp } = decode(refreshToken);
    // console.log(new Date().getTime() / 1000,"new Date().getTime() / 1000")
    // let test  = new Date();
    // const utcStr = test.getUTCMilliseconds();
    // console.log(new Date().getMilliseconds() / 1000,"new Date().getMilliseconds()")
    if (exp < new Date().getTime() / 1000) {
      LocalStorageService.clear();
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
};

const AuthRoute = ({ component: Component, roles, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!checkAuth()) {
        return <Redirect to={{ pathname: "/" }} />;
      }
      const usrRole = LocalStorageService.get("user-role");
      // check if route is restricted by role
      if (roles && roles.indexOf(usrRole) === -1) {
        // role not authorised so redirect to home page
        return <Redirect to={{ pathname: "/" }} />;
      }

      return <Component {...props} />;
    }}
  />
);

const App = () => {
  // Define as many global variables as your app needs, and hooks
  // to set the state of the variable.
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    console.log("location", window.location.pathname + window.location.search);
  }, [window.location]);
  const [navOpen, setNavOpen] = useState(true);

  const setNavOpens = (navOpen) => {
    setNavOpen(navOpen);
  };

  const userSettings = {
    navOpen: navOpen,
    setNavOpens,
  };

  // componentDidMount() {
  // setTimeout(() => {
  // AOS.init({
  // offset: isMobile ? 10 : 100,
  // });
  // AOS.refresh();
  // }, 1500);
  // }

  //render() {
  return (
    <AppContext.Provider value={userSettings}>
      <Router hashType="noslash" basename={process.env.BASE_PATH}>
        <Switch>
          <Route exact path="/">
            {/* <div>
 Bss Screen List: <br />
 <Link to="/Dashboard">Dashboard</Link><br/>
 <Link to="/site">Site</Link><br/>
 <Link to="/SiteListing">SiteListing</Link><br/>
 <Link to="/batteries/battery">Battery</Link><br/>
 <Link to="/BattriesList">BattriesList</Link><br/>
 </div> */}
            <Route exact path="/" component={SignIn} />
          </Route>
          <Route exact path="/ForgotPassword" component={ForgotPassword} />
          <Route exact path="/ResetPassword" component={ResetPassword} />

          <Route exact path="/UserProfile" component={UserProfile} />
          <Route
            exact
            path="/terms_conditions"
            component={TermsConditionsPortal}
          />
          <Route exact path="/privacy_policy" component={PrivacyPolicyPortal} />
          <Route
            exact
            path="/app_privacy_policy"
            component={PrivacyPolicyApp}
          />
          <Route
            exact
            path="/app_terms_condition"
            component={TermsConditionsApp}
          />
          <Route exact path="/faq" component={FaqPage} />

          {/* <AuthRoute
 exact
 path="/site"
 component={Site}
 roles={[role_admin, role_super_admin, role_operator]}
 /> */}
          <AuthRoute
            exact
            path="/SwapStation/SwappingStationView"
            component={SwapingStation}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/Alerts"
            component={Alerts}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute exact path="/Invoice/AddInvoice" component={AddInvoice} />
          <AuthRoute exact path="/Schedule" component={Schedule} />
          <AuthRoute
            exact
            path="/Schedule/AddSchedule"
            component={AddSchedule}
          />
          <AuthRoute
            exact
            path="/Invoice/ViewInvoice/:id/:view"
            component={AddInvoice}
          />
          <AuthRoute
            exact
            path="/Invoice/UpdateInvoice/:id"
            component={AddInvoice}
          />
          <AuthRoute
            exact
            path="/Schedule/UpdateSchedule/:id"
            component={AddSchedule}
          />

          <AuthRoute exact path="/Invoice" component={Invoice} />
          <AuthRoute
            exact
            path="/Invoice/PriceInvoice"
            component={PriceInvoice}
          />
          <AuthRoute exact path="/Pricing/AddPricing" component={Addpricing} />
          <AuthRoute exact path="/Pricing" component={Pricing} />

          <AuthRoute
            exact
            path="/Dashboard"
            component={Dashboard}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/Reports"
            component={reports}
            roles={[role_admin, role_super_admin, role_operator]}
          /> 
          <AuthRoute
            exact
            path="/Tracking"
            component={Tracking}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/Track"
            component={Track}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/batteries/battery/:id/:batterySerial"
            component={Battery}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/batteries"
            component={BattriesList}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/SiteInformation"
            component={SiteInformation}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/sites"
            component={SiteListing}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/ServiceRequest"
            component={ServiceRequest}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/ServiceRequest/ServiceListing"
            component={ServiceListing}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/ServiceRequest/UpdateService/:id"
            component={ServiceListing}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/ServiceRequest/ViewService/:id/:view"
            component={ServiceListing}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          {/* serviceRequest */}
          <AuthRoute
            exact
            path="/sites/site/:id/:name/:enterpriseName/:view"
            component={Site}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/SwapStation/SwapStation/:id"
            component={SwappingDetails}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/swapStation/:id"
            component={SwapingStation}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/Swapping"
            component={Swapping}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/ServiceRequest"
            component={ServiceRequest}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/ServiceRequest/ServiceListing"
            component={ServiceListing}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/ViewService/:id"
            component={ViewService}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          {/* <AuthRoute
       exact
      path="/sites/analytics"
     component={Analytics}
     roles={[role_admin, role_super_admin, role_operator]}
 /> */}
          <AuthRoute
            exact
            path="/SwapStation"
            component={SwappingStationEnergyComponent}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/Assets"
            component={Assets}
            roles={[role_admin, role_super_admin, role_operator]}
          />
          <AuthRoute
            exact
            path="/AddBattery"
            component={AddBattery}
            roles={[role_admin, role_super_admin, role_operator]}
          />

          <AuthRoute
            exact
            path="/Assets/AddSwapStation"
            component={AddSwapStation}
          />
          <AuthRoute
            exact
            path="/Assets/updateSwapStation/:id"
            component={AddSwapStation}
          />
          <AuthRoute
            exact
            path="/Assets/SwapStation/:id/:view"
            component={AddSwapStation}
          />

          <AuthRoute exact path="/Assets/AddZone" component={Addzone} />
          <AuthRoute exact path="/Assets/updateZone/:id" component={Addzone} />

          <AuthRoute
            exact
            path="/Assets/viewZone/:id/:view"
            component={Addzone}
          />

          <AuthRoute exact path="/Assets/AddSite" component={AddSite} />

          <AuthRoute exact path="/Assets/UpdateSite/:id" component={AddSite} />

          <AuthRoute
            exact
            path="/Assets/ViewSite/:id/:view"
            component={AddSite}
          />

          <AuthRoute exact path="/Assets/addBattery" component={AddBattery} />
          <AuthRoute
            exact
            path="/Assets/UpdateBattery/:id"
            component={AddBattery}
          />
          <AuthRoute
            exact
            path="/Assets/ViewBattery/:id/:view"
            component={AddBattery}
          />

          <AuthRoute exact path="/Assets/addMakers" component={AddMakers} />
          <AuthRoute
            exact
            path="/Assets/updateMakers/:id"
            component={AddMakers}
          />
          <AuthRoute
            exact
            path="/Assets/viewMakers/:id/:view"
            component={AddMakers}
          />

          <AuthRoute exact path="/Assets/addModel" component={AddModel} />
          <AuthRoute
            exact
            path="/Assets/updateModel/:id"
            component={AddModel}
          />
          <AuthRoute
            exact
            path="/Assets/viewModel/:id/:view"
            component={AddModel}
          />

          <AuthRoute exact path="/Assets/addVehicle" component={AddVehicle} />
          <AuthRoute
            exact
            path="/Assets/updateVehicle/:id"
            component={AddVehicle}
          />
          <AuthRoute
            exact
            path="/Assets/viewVehicle/:id/:view"
            component={AddVehicle}
          />

          <AuthRoute exact path="/Users" component={UserList} />
          <AuthRoute exact path="/Users/addAdmin" component={AddAdmin} />
          <AuthRoute exact path="/Users/updateAdmin/:id" component={AddAdmin} />
          <AuthRoute
            exact
            path="/Users/viewAdmin/:id/:view"
            component={AddAdmin}
          />
          <AuthRoute exact path="/Users/addOperator" component={AddOperator} />
          <AuthRoute
            exact
            path="/Users/updateOperator/:id"
            component={AddOperator}
          />
          <AuthRoute
            exact
            path="/Users/viewOperator/:id/:view"
            component={AddOperator}
          />
          <AuthRoute exact path="/Users/addDriver" component={AddDriver} />
          <AuthRoute
            exact
            path="/Users/updateDriver/:id"
            component={AddDriver}
          />
          <AuthRoute
            exact
            path="/Users/viewDriver/:id/:view"
            component={AddDriver}
          />
          <AuthRoute exact path="/Users/addRole" component={AddRole} />
          <AuthRoute exact path="/Users/updateRole/:id" component={AddRole} />
          <AuthRoute
            exact
            path="/Users/viewRole/:id/:view"
            component={AddRole}
          />
          <AuthRoute exact path="/Fota" component={FotaMain} />
          <AuthRoute
            exact
            path="/Fota/ViewFirmware/:id"
            component={AddFirmware}
          />
          <AuthRoute
            exact
            path="/Fota/editFirmware/:id"
            component={EditFirmware}
          />
          <AuthRoute
            exact
            path="/Fota/uploadFirmware"
            component={EditFirmware}
          />
          <AuthRoute
            exact
            path="/Fota/ViewSwapStation/:id"
            component={ViewFirmwareSwapStation}
          />
        </Switch>
        <NotificationContainer />
      </Router>
    </AppContext.Provider>
  );
  // }
};

export default App;
